<template>
  <div>
    <ul class="cart__orders">
      <li class="cart__order" v-for="product in $store.state.cartProductsData" :key="product.id">
        <h3>{{ product.product.title }}</h3>
        <b>{{ (product.price * product.quantity) | numberFormat }} Р</b>
        <span>{{ product.id }}</span>
      </li>
    </ul>
    <div class="cart__total">
      <p>Доставка: <b>500 ₽</b></p>
      <p>Итого: <b>{{ totalNum }}</b> на сумму <b>{{totalPrice | numberFormat}} ₽</b></p>
    </div>
  </div>
</template>

<script>
import numberFormat from '@/helpers/numberFormat';
import { mapGetters } from 'vuex';

export default {
  filters: {
    numberFormat,
  },
  computed: {
    ...mapGetters({ products: 'cartDetailProducts', totalPrice: 'cartTotalPrice', totalNum: 'cartTotalName' }),
  },
};
</script>
